const getTranslate3d = (val: string): string[] => {
  const values = val.split(/\w+\(|\);?/);
  if (!values[1] || !values[1].length) {
    return [];
  }
  return values[1].split(/,\s?/g);
};

export default getTranslate3d;
